@if (!isLoading && !comoUser && (isComoEnabled$ | async)) {
  <app-mosaic-como-long-push-atom
    [heading]="heading ? heading : 'como.join-loyalty'"
    [text]="text ? text : 'como.benefit-from-offers'"
    [textColor]="textColor"
    [backgroundColor]="backgroundColor"
    (click)="onClick()"
  >
  </app-mosaic-como-long-push-atom>
}
